"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterItem = void 0;
var list_1 = require("types/list");
var utils_1 = require("./utils");
var filterItem = function (columns, keys, item, filterOptions) {
    var mapReduce = function (status, key) {
        if (status) {
            var col = columns[key];
            var value = item[key];
            var filter = filterOptions[key];
            if (filter !== undefined) {
                switch (col === null || col === void 0 ? void 0 : col.type) {
                    case list_1.ListColumnType.text: {
                        var text = (0, utils_1.mapLocalization)(value);
                        return text.includes(filter);
                    }
                }
            }
        }
        return status;
    };
    return keys.reduce(mapReduce, true);
};
exports.filterItem = filterItem;
